import { useBulkDelete } from '@/shared/lib';
import { departmentApi, type Department } from '@/entities/Department';

async function getDeleteDescription(departmentIds: number[]): Promise<string> {
  const { hasLinks } = await departmentApi.checkLinks(departmentIds);

  if (!hasLinks) {
    return 'A ação não pode ser desfeita.';
  }

  return departmentIds.length === 1
    ? 'Este departamento possui cargos vinculados. Ao excluí-lo, esses cargos ficarão sem departamento. A ação não pode ser desfeita.'
    : 'Um ou mais departamentos selecionados possuem cargos vinculados. Ao excluí-los, esses cargos ficarão sem departamento. A ação não pode ser desfeita.';
}

export function useDepartmentDelete(
  selectedCount: () => number,
  selectedDepartmentsArray: () => number[],
  onDeleteSuccess: (deletedIds: number[]) => void,
  removeFromSelection: (ids: number[]) => void,
  onModalClose?: () => void
) {
  return useBulkDelete<Department>({
    entityName: {
      singular: 'departamento',
      plural: 'departamentos',
    },
    bulkDeleteApi: departmentApi.bulkDelete,
    getDeleteDescription,
    onDeleteSuccess,
    removeFromSelection,
    selectedCount,
    selectedIds: selectedDepartmentsArray,
    onModalClose,
  });
}
